import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
// import Vuetify from 'vuetify/lib';
import VueSession from 'vue-session';
// import './plugins/axios';
import App from './App.vue';
import Utils from '@/utils/Utils';
import { EventBus } from '@/EventBus';
import router from './Router';
// import 'vuetify/src/stylus/app.styl';
// import 'vuetify/dist/vuetify.min.css'

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
// v2.0

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

// import plugin
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles
import 'vuetify/dist/vuetify.min.css'

// import Vuetify from 'vuetify/lib';

const opts = {
    icons: {
        iconfont: ['mdiSvg']  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
        // iconfont: 'md',  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#3EBE32',
                secondary: '#9EDE98',
                accent: '#2B8523'
            },
            dark: {
                primary: '#3EBE32',
                secondary: '#9EDE98',
                accent: '#2B8523'
            }
        }
    }
}
Vue.use(Vuetify);

// Vue.use(Vuetify);

// Vue.use(Vuetify, {
//   iconfont: 'md'
// });
Vue.use(VueSession, { persist: true }); // Persiste a sessao em todas as abas do navegador em que a aplicacao estiver rodando

Vue.config.productionTip = false;

const vuetify = new Vuetify;
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md'
});

// Intercepta as mudancas de rota e verifica se a sessao existe e está ativa
/*
router.beforeEach((to, from, next) => {
    if (['/login', '/logout'].indexOf(to.path) < 0) {
        // // Busca as cidades cadastradas e guarda na variavel global
        // if (!Vue.prototype.$SOLICITACOES.cidades.loaded) {
        //     Utils.apiAjax({
        //         url: '/cidades',
        //         success: (data) => {
        //             if (data.success) {
        //                 Vue.prototype.$SOLICITACOES.cidades.loaded = true;
        //                 Vue.prototype.$SOLICITACOES.cidades.data = data.data.map((cidade) => {
        //                     cidade.nomeuf = `${cidade.nome} / ${cidade.estado.sigla}`; // eslint-disable-line no-param-reassign
        //                     return cidade;
        //                 });
        //                 EventBus.$emit('showPopUp', {
        //                     text: 'Dados carregados.'
        //                 });
        //             }
        //         },
        //         failure: () => {}
        //     });
        // }

        // // Busca os tipos de solicitacao cadastrados e guarda na variavel global
        // if (!Vue.prototype.$SOLICITACOES.solicitacoesTipos.loaded) {
        //     Utils.apiAjax({
        //         url: '/util/solicitacoesTipos',
        //         success: (data) => {
        //             if (data.success) {
        //                 Vue.prototype.$SOLICITACOES.solicitacoesTipos.loaded = true;
        //                 Vue.prototype.$SOLICITACOES.solicitacoesTipos.data = data.data;
        //             }
        //         },
        //         failure: () => {}
        //     });
        // }

        // // Busca os solicitantes cadastrados e guarda na variavel global
        // if (!Vue.prototype.$SOLICITACOES.solicitantes.loaded) {
        //     Utils.apiAjax({
        //         url: '/util/solicitantes',
        //         success: (data) => {
        //             if (data.success) {
        //                 Vue.prototype.$SOLICITACOES.solicitantes.loaded = true;
        //                 Vue.prototype.$SOLICITACOES.solicitantes.data = data.data;
        //             }
        //         },
        //         failure: () => {}
        //     });
        // }

        // // Busca os correspondentes cadastrados e guarda na variavel global
        // if (!Vue.prototype.$SOLICITACOES.correspondentes.loaded) {
        //     Utils.apiAjax({
        //         url: '/util/correspondentes',
        //         success: (data) => {
        //             if (data.success) {
        //                 Vue.prototype.$SOLICITACOES.correspondentes.loaded = true;
        //                 Vue.prototype.$SOLICITACOES.correspondentes.data = data.data;
        //             }
        //         },
        //         failure: () => {}
        //     });
        // }

        // // Busca os faturamentos cadastrados e guarda na variavel global
        // if (!Vue.prototype.$SOLICITACOES.faturamentos.loaded) {
        //     Utils.apiAjax({
        //         url: '/util/faturamentos',
        //         success: (data) => {
        //             if (data.success) {
        //                 Vue.prototype.$SOLICITACOES.faturamentos.loaded = true;
        //                 Vue.prototype.$SOLICITACOES.faturamentos.data = data.data;
        //             }
        //         },
        //         failure: () => {}
        //     });
        // }

        Utils.apiAjax({
            url: '/permissoes/Autenticacao',
            success: (data) => {
                if (data.success === false) {
                    const sessionObj = JSON.parse(localStorage.getItem('vue-session-key')) || {};
                    if (sessionObj.Sessao !== undefined && sessionObj.Sessao !== '') {
                        localStorage.setItem('vue-session-solicitacoes-expired', 'EXPIRED');
                    }
                    next({ path: '/login' });
                } else {
                    next();
                }
            },
            failure: () => {
                const sessionObj = JSON.parse(localStorage.getItem('vue-session-key')) || {};
                if (sessionObj.Sessao !== undefined && sessionObj.Sessao !== '') {
                    localStorage.setItem('vue-session-solicitacoes-expired', 'EXPIRED');
                }
                next({ path: '/login' });
            }
        });
    } else {
        next();
    }
});
*/

Vue.prototype.$TCHETASKS = {
    cidades: {
        loaded: false,
        data: []
    },
    solicitacoesTipos: {
        loaded: false,
        data: []
    },
    solicitantes: {
        loaded: false,
        data: []
    },
    correspondentes: {
        loaded: false,
        data: []
    },
    faturamentos: {
        loaded: false,
        data: []
    }
};

new Vue({
    router,
    vuetify: new Vuetify(opts),
    render: h => h(App)
}).$mount('#app');